import type { JSX } from 'react';
import { cn } from '@packages/shared/src/utils/cn/cn';
import { type CmsData, ComponentTypes } from '../../../../interfaces';
import type { FooterBlockType } from '../types';
import { ModalByTextlink } from '../../ModalByTextlink/ModalByTextlink';
import { Html } from '../../Html/Html';

type SocketProps = {
  data: CmsData;
};

export const AreaSocket = ({ data }: SocketProps): JSX.Element => {
  const comp = (data.paragraph as FooterBlockType[])
    ?.filter((item) => item.parent_field_name === 'field_socket')
    ?.map((item, index) => {
      const keyModalByTextlink = `socket-${ComponentTypes.TextlinkModal}-${index}`;
      const keyHtml = `socket-${ComponentTypes.Html}-${index}`;
      if (item.type === ComponentTypes.TextlinkModal) {
        return <ModalByTextlink key={keyModalByTextlink} data={item} />;
      }

      if (item.type === ComponentTypes.Html) {
        return <Html key={keyHtml} data={item} />;
      }

      return <div />;
    });

  if (data && comp.length > 0) {
    return (
      <div
        className={cn(
          'text-color-text mx-auto max-w-screen-xl',
          '[&_p]:m-0 [&_p]:p-0',
          // Todo: Get rid of important when ModalByTextlink refactored to tailwind
          '[&_a]:text-color-text! [&_a]:decoration-color-text! [&_a]:no-underline',
          '[&_p_+_p]:pt-1.5! md:[&_p_+_p]:pt-1!',
          'px-2! pt-3 pb-[4.5rem] md:px-0!',
          'text-size-body2 md:text-size-body3',
        )}
      >
        {comp}
      </div>
    );
  }

  return <div />;
};
